export enum EmployeeAbsenceStatus {
    Absent = 0,
    Work = 1,
    Customer = 2,
    Home = 3,
    Idle = 4,
    Meeting = 5,
    Tentative = 6
}
